/**
 * Renderer-side API for chart export (PNG/SVG).
 */

import type { ChartExportFormat } from '../types/chartTypes';

export type ChartExportRequest = {
  svgContent: string;
  format: ChartExportFormat;
  suggestedFileName?: string;
};

export type ChartExportResult = {
  success: boolean;
  filePath?: string;
  cancelled?: boolean;
  error?: string;
};

/**
 * Export a chart to a file (PNG or SVG).
 *
 * @param svgContent - The SVG content to export
 * @param format - The export format (png or svg)
 * @param suggestedFileName - Optional suggested file name
 * @returns Export result with success status and file path
 */
export async function exportChart(
  svgContent: string,
  format: ChartExportFormat,
  suggestedFileName?: string
): Promise<ChartExportResult> {
  if (!window.electronAPI) {
    return { success: false, error: 'Electron API not available' };
  }

  const request: ChartExportRequest = {
    svgContent,
    format,
    suggestedFileName,
  };

  return window.electronAPI.exportChart(request);
}
